// Stable tint for a pillar's UI accents. The six legacy pillars keep their
// original brand hues (visual continuity with the retired .p-* classes),
// matched by name; any other pillar gets a deterministic hash-derived hue at
// the same neon saturation/lightness, keyed by pillar_id so the color survives
// renames.
const LEGACY: Record<string, string> = {
  $$$: "#00e5a0",
  Vision: "#f50090",
  PerfOrg: "#d4f544",
  Market: "#e040fb",
  Product: "#c044ff",
  Mothership: "#ff4fd8"
};

export function pillarTint(id: string | null, name: string | null): string {
  if (name !== null && name !== "") {
    const legacy = LEGACY[name];
    if (legacy !== undefined) {
      return legacy;
    }
  }
  const key = id ?? name;
  if (key === null || key === "") {
    return "var(--color-border, #444)";
  }
  let hash = 0;
  for (let i = 0; i < key.length; i++) {
    hash = (hash * 31 + key.charCodeAt(i)) >>> 0;
  }
  return `hsl(${hash % 360} 85% 62%)`;
}
